import { func, object } from 'prop-types';
import React from 'react';

import QuestionBlock from './QuestionBlock';
import RehabHeader from './RehabHeader';

const Rehab2 = ({ fm, data, fatigueData }) => {
  return (
    <React.Fragment>
      <RehabHeader fm={fm} rehab={2} date={data.finished} />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab2.1.whenAreYouFatigued')}
        answer={data.whenAreYouFatigued}
      />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab2.1.whatCausesTheFatigue')}
        answer={data.whatCausesTheFatigue}
      />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab2.1.factorsToEaseFatigue')}
        answer={data.factorsToEaseFatigue}
      />
      <QuestionBlock
        question={fm('npView.rehab2.appInUse')}
        answer={
          fatigueData && typeof fatigueData === 'object' && Object.keys(fatigueData).length !== 0
            ? fm(`npView.true`)
            : null
        }
      />
    </React.Fragment>
  );
};

Rehab2.propTypes = {
  fm: func,
  data: object,
  fatigueData: object,
};
export default Rehab2;
